import { ADD_LIST_API_PREFIX } from '@aibees/elephant/constants';
import { CreateLabelRequest, Label } from '@aibees/elephant/types/label';
import { useBootstrapApiBase } from '@aibees/shared/api';
import { HttpMethod } from '@aibees/shared/definition';
import { useDebounceFn } from '@aibees/shared/hooks';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { useBrowseLabel } from './use-browse-label';

export function useCreateList() {
  const workspaceId = useWorkspace()?.id;
  const invalidateDebounced = useDebounceFn(() => {
    baseQueryClient.invalidateQueries([useBrowseLabel.name]);
    baseQueryClient.invalidateQueries([useBootstrapApiBase.name, workspaceId]);
    baseQueryClient.invalidateQueries({
      predicate: (query) => {
        const { queryKey } = query;
        return (
          Array.isArray(queryKey) &&
          queryKey.includes('lists_and_labels_filter_options_query')
        );
      },
    });
  }, 1000);

  return useBaseMutation<CreateLabelRequest, Label>(
    {
      url: ADD_LIST_API_PREFIX.replace(':wid', String(workspaceId)),
      method: HttpMethod.post,
    },
    {
      onSettled() {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        invalidateDebounced();
      },
    }
  );
}
